import React from 'react';

import { PageHeader } from '../ui/PageHeader';
import { Card } from '../ui/Card';

const expertiseSections = [
  {
    kicker: 'Verification of Local Operators',
    title: 'Verification of Local Operators',
    bullets: [
      'A rigorous process ensuring operators meet ethical, safety, and community‑impact standards',
    ],
    image: '/images/places/ngorongoro-crater-lodge.jpg',
    imageAlt: 'Operator verification and oversight',
  },
  {
    kicker: 'Guide Certification & Oversight',
    title: 'Guide Certification & Oversight',
    bullets: ['Ensuring travelers are led by trained, trusted, and community‑aligned guides'],
    image: '/images/trips/safari-camp.jpg',
    imageAlt: 'Trained guides and oversight',
  },
  {
    kicker: 'Contract & Paperwork Management',
    title: 'Contract & Paperwork Management',
    bullets: ['We handle the administrative workload so agencies can focus on their clients'],
    image: '/images/trips/kilimanjaro-group-hike.jpg',
    imageAlt: 'Administrative support for partner agencies',
  },
  {
    kicker: 'Ethical Travel Compliance',
    title: 'Ethical Travel Compliance',
    bullets: ['Standards that protect communities, wildlife, and travelers'],
    image: '/images/wildlife/rhinos.jpg',
    imageAlt: 'Compliance and ethical standards',
  },
  {
    kicker: 'On‑Ground Support in Tanzania',
    title: 'On‑Ground Support in Tanzania',
    bullets: ['A local team ensuring quality, communication, and accountability'],
    image: '/images/community/maasai-community-dance.jpg',
    imageAlt: 'On-ground support and communication',
  },
];

export default function ExpertisePage() {
  return (
    <div className="page heroPage">
      <div className="container">
        <PageHeader
          kicker="Our Expertise"
          title="Operational Excellence for Ethical Safaris"
          subtitle="Professional support for travel agencies through verified networks and reliable on‑ground operations."
        />

        <p className="muted" style={{ marginTop: 0, lineHeight: 1.7, maxWidth: 900 }}>
          SafariCo Hub provides the operational backbone that allows travel agencies to deliver ethical, high‑quality safari experiences with confidence.
        </p>

        <div className="grid" style={{ marginTop: 22, gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
          {expertiseSections.map((sec) => (
            <Card key={sec.title} title={sec.title}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <img className="mediaImage" src={sec.image} alt={sec.imageAlt} />
                <div className="kicker">{sec.kicker}</div>
                <div className="missionList" style={{ marginTop: 0 }}>
                  {sec.bullets.map((b) => (
                    <div key={b} className="missionItem">
                      <span className="missionDot" aria-hidden="true" />
                      <span>{b}</span>
                    </div>
                  ))}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
  );
}

